import { t } from "@/i18n-js/instance";
import { OverviewStatComponent } from "@/react/components/Analytics/components/OverviewStatComponent";
import { i18nRoot } from "../../constants";
import {
  useVideoAnalyticsAverageDuration,
  useVideoAnalyticsTotalDuration,
} from "../hooks/useVideoAnalytics";
import { formatDuration } from "../utils/formatDuration";

interface TimeWatchedMetricsProps {
  endDate?: string;
  signedId: string;
  startDate?: string;
}

export const TimeWatchedMetrics = ({
  signedId,
  startDate,
  endDate,
}: TimeWatchedMetricsProps) => {
  const { data: averageDuration, isLoading: isLoadingAverageDuration } =
    useVideoAnalyticsAverageDuration({
      signedId,
      startDate,
      endDate,
    });

  const { data: totalDuration, isLoading: isLoadingTotalDuration } =
    useVideoAnalyticsTotalDuration({
      signedId,
      startDate,
      endDate,
    });

  return (
    <div className="mb-8 grid grid-cols-1 gap-6 md:grid-cols-2">
      <OverviewStatComponent
        title={t([i18nRoot, "analytics.metrics.average_duration.title"])}
        value={formatDuration(averageDuration ?? 0)}
        tooltip={t([i18nRoot, "analytics.metrics.average_duration.tooltip"])}
        className="w-full"
        isLoading={isLoadingAverageDuration}
      />
      <OverviewStatComponent
        title={t([i18nRoot, "analytics.metrics.total_duration.title"])}
        value={formatDuration(totalDuration ?? 0)}
        tooltip={t([i18nRoot, "analytics.metrics.total_duration.tooltip"])}
        className="w-full"
        isLoading={isLoadingTotalDuration}
      />
    </div>
  );
};
